// extracted by mini-css-extract-plugin
export default {"line":"editAndAddSupplier_line__w58De","button":"editAndAddSupplier_button__DQOY6"};